<section *ngIf="myUnit$ | async as unit" class="my-company-addresses">
  <ul *ngFor="let address of unit.addresses" class="my-company-addresses__address">
    <li class="my-company-addresses__address__info">
      {{address.line1}}
    </li>
    <li class="my-company-addresses__address__info">
      {{address.town}}
    </li>
    <li class="my-company-addresses__address__info">
      {{address.country?.name}} {{address.postalCode}}
    </li>
    <li class="my-company-addresses__address__button" *ngIf="defaultAddress$ | async as defaultAddress">
      <button
        [className]="
          (address.id === defaultAddress.id) ? 'my-company-addresses__address__button--default' : 'my-company-addresses__address__button--notdefault'
        "
        (click)="defineAsDefault($event, address)"
      >
        {{'gonvarri.company.addresses.default' | cxTranslate}}
      </button>
    </li>
  </ul>
</section>
